import type { SVGProps } from "react";

export const MicrosoftDynamics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="488.212px"
    preserveAspectRatio="none"
    viewBox="61.0904 5.5368 355.9882 488.2116"
    width="355.988px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Microsoft dynamics</title>
    <g
      clipPath="url(#clip0)"
      id="object-0"
      style={{}}
      transform="matrix(5.085537910461426, 0, 0, 5.085537910461426, 0.06396700537156619, 5.53684815074277)"
    >
      <defs>
        <filter id="filter0_f">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feGaussianBlur result="effect1_foregroundBlur" stdDeviation="0.4" />
        </filter>
        <filter id="filter1_f">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feGaussianBlur result="effect1_foregroundBlur" stdDeviation="4" />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="38.0451"
          x2="56.6585"
          y1="-1"
          y2="47.7233"
        >
          <stop stopColor="#0B53CE" />
          <stop offset="1" stopColor="#7252AA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear"
          x1="64.1377"
          x2="64.1377"
          y1="93.4922"
          y2="35.4151"
        >
          <stop stopColor="#2266E3" />
          <stop offset="1" stopColor="#AE7FE2" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear"
          x1="82"
          x2="62.0764"
          y1="56.7858"
          y2="56.7858"
        >
          <stop stopColor="#94B9FF" />
          <stop offset="0.2878" stopColor="#94B9FF" stopOpacity="0.523646" />
          <stop offset="1" stopColor="#538FFF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect fill="white" height="96" width="96" />
        </clipPath>
      </defs>
      <mask
        height="96"
        id="mask0"
        maskContentUnits="alpha"
        maskUnits="userSpaceOnUse"
        width="70"
        x="12"
        y="0"
      >
        <path
          d="M82.0001 31.047C82.0001 26.8209 79.3434 23.051 75.3634 21.6296L17.3453 0.90903C14.7404 -0.0213096 12 1.90988 12 4.676V36.1811C12 37.8715 13.0627 39.3795 14.6547 39.9481L40.6547 49.2338C43.2596 50.1641 46 48.2329 46 45.4668V27.3768C46 25.9794 47.3966 25.0127 48.7044 25.5049L55.5222 28.0707C59.4195 29.5374 62 33.2657 62 37.4299V45.3076L32.6272 56.0399C31.0495 56.6164 30 58.1172 30 59.797V91.2797C30 94.0582 32.7631 95.9903 35.3728 95.0367L75.432 80.3996C79.3763 78.9584 82 75.2064 82 71.007L82.0001 31.047Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M12 -1L82.0001 23.9998V58.3245C82.0001 61.0905 79.2601 63.0217 76.6551 62.0917L62 56.8593V37.4241C62 33.258 59.4171 29.5283 55.5172 28.063L48.7034 25.5029C47.3957 25.0116 46 25.9782 46 27.3751V51.1428L12 39V-1Z"
          fill="url(#paint0_linear)"
        />
        <g filter="url(#filter0_f)">
          <path
            d="M82 31.3998V31.3998C82 35.5992 79.3763 39.3586 75.4319 40.7998L30 57.3999V97.3999L82 78.3998V31.3998Z"
            fill="black"
            fillOpacity="0.24"
          />
        </g>
        <g filter="url(#filter1_f)">
          <path
            d="M82 32.9998V32.9998C82 37.1992 79.3763 40.9585 75.4319 42.3997L30 58.9999V98.9999L82 79.9998V32.9998Z"
            fill="black"
            fillOpacity="0.32"
          />
        </g>
        <path
          d="M82 30.9998V30.9998C82 35.1992 79.3763 38.9585 75.4319 40.3997L30 56.9999V96.9999L82 77.9998V30.9998Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M82 30.9998V30.9998C82 35.1992 79.3763 38.9585 75.4319 40.3997L30 56.9999V96.9999L82 77.9998V30.9998Z"
          fill="url(#paint2_linear)"
          opacity="0.5"
        />
        <path
          d="M62.0013 45.3202L45.9922 51.1768L45.9923 74.6349C45.9923 76.0323 47.389 76.9989 48.6968 76.5066L55.5241 73.9368C59.4211 72.4699 62.0013 68.7418 62.0013 64.5779V45.3202Z"
          fill="#B0ADFF"
          opacity="0.5"
        />
      </g>
    </g>
  </svg>
);

export default MicrosoftDynamics;
